import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Paper,
  TextField,
  MenuItem,
  Stack,
  Grid,
  CircularProgress,
  Backdrop,
  Divider,
  FormControl,
  InputLabel,
  Select
} from '@material-ui/core';
import moment from 'moment';
import PublishIcon from '@material-ui/icons/Publish';
import { v4 as uuidv4 } from 'uuid';
import { FixedWidthParser } from 'fixed-width-parser';
import { baseUrl, employers } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';
import Controls from '../controls/Controls';
import Page from '../Page';

const ExtractSsb = () => {
  const { subsAmount, assureAmount } = useSettingContext();
  const { payCycles } = useConstantsContext();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [currency, setCurrency] = useState(0);
  const [cycleRefId, setCycleRefId] = useState(0);
  const [subAmount, setSubsAmount] = useState(subsAmount);
  const [insuranceAmount, setAssureAmount] = useState(assureAmount);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [employerRefId, setEmployerRefId] = useState(1);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const navigate = useNavigate();
  const currencies = [
    {
      value: 1,
      label: 'USD'
    },
    {
      value: 2,
      label: 'Zim Dollar'
    }
  ];
  const downloadDocument = (e) => {
    const fixedWidthParser = new FixedWidthParser([
      {
        // type: 'int',
        name: 'extraInfo',
        start: 0,
        width: 50
      },
      {
        name: 'idnumber',
        start: 51,
        width: 12
      },
      {
        name: 'employeeName',
        start: 66,
        width: 20
      },
      {
        name: 'amount',
        start: 96,
        width: 10
      },
      {
        name: 'decimals',
        start: 106,
        width: 2
      },
      {
        name: 'descr',
        start: 108,
        width: 8
      },
      {
        name: 'employeenumber',
        start: 118,
        width: 8
      },
      {
        name: 'reference',
        start: 126,
        width: 12
      }
    ]);

    const result = fixedWidthParser.parse(e);
    result.forEach((data) => {
      data.amount = Number(`${data.amount}.${data.decimals}`);
      data.descr = moment(data.descr, 'YYYYMMDD').format('yyyy-MM-DD');
    });
    result.shift();
    result.pop();

    setDetails(result);
    console.log('result2 is', result);
    setLoading(false);
  };

  const handleImport = (e) => {
    setLoading(true);
    setDetails([]);
    const { files } = e.target;

    if (files.length) {
      const file = files[0];
      console.log('file contents', file);
      setUploadedFile(file);
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        // console.log(text)
        // alert(text)
        downloadDocument(text);
      };
      reader.readAsText(e.target.files[0]);
    }
  };

  const saveSsbFile = () => {
    if (insuranceAmount < 0) {
      notifyPopup(`No Provident Amount Entered, Please enter it...!`, 'error');
      return;
    }
    if (uploadedFile.length === 0) {
      notifyPopup(`Please select file to upload!`, 'error');
      return;
    }
    setLoading(true);
    const jsonClient = [];
    const jsonData = {
      employerRefId: 1,
      ssbFileName: uploadedFile.name,
      upLoadDate: new Date(),
      upLoadedBy: sessionStorage.getItem('userRefId'),
      processState: 0,
      subsAmount: subAmount,
      insuranceAmount,
      exchangeRate,
      fileType: 1,
      currency
    };
    jsonClient.push(jsonData);
    console.log('ssbFile stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/ssb/saveSsbFile`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          saveSsbFileDetails(result.refId);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Receipts!: ${error}`, 'error');
        }
      );
  };

  const saveSsbFileDetails = async (result) => {
    // setLoading(true);
    const receipts = details.map((obj) => ({
      ...obj,
      ssbFileRefId: result,
      processed: false,
      id: uuidv4()
    }));
    const jsonData = {
      receipts
    };
    console.log('jsonDate: ', jsonData.receipts);
    const jsonClient = [];
    jsonClient.push(jsonData.receipts);
    console.log('ssbFile Details stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/ssb/saveSsbFileDetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned SaveSsbFileDetails', res);
          setLoading(false);
          navigate(`/accounts/receiptfile`);
          // notifyPopup(`details Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Updating Details!: ${error}`, 'error');
        }
      );
  };

  const saveSsbFiles = () => {
    const receipts = details.map((obj) => ({
      ...obj,
      ssbFileRefId: 34,
      processed: false,
      id: uuidv4()
    }));
    const jsonData = {
      receipts
    };
    console.log('jsonDate: ', jsonData.receipts);
  };

  const employerListProps = {
    options: employers,
    getOptionLabel: (options) => `${options.name}`
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Page title="SSB File Extract">
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography variant="h4">Extract SSB File</Typography>
      <Stack direction="row" alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
        <Box component="span" sx={{ p: 1, border: '1px solid grey', borderRadius: 1 }}>
          <input
            type="file"
            name="file"
            className="custom-file-input"
            id="inputGroupFile"
            required
            onChange={handleImport}
            // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </Box>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={2}>
            <TextField
              id="subsAmount"
              style={{ width: 120, height: 30, pb: 2, ml: 2 }}
              size="small"
              label="Subs Amount"
              value={subsAmount}
              onChange={(e) => setCurrency(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              id="insuranceAmount"
              style={{ width: 120, height: 30, pb: 2 }}
              size="small"
              label="Provident Amount"
              value={insuranceAmount}
              onChange={(e) => setCurrency(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              id="exchangeRate"
              style={{ width: 120, height: 30, pb: 2 }}
              size="small"
              label="Exchange Rate"
              value={exchangeRate}
              onChange={(e) => setExchangeRate(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id="cycleRefId"
              style={{ width: 180, height: 30, pb: 2 }}
              select
              size="small"
              value={cycleRefId}
              onChange={(e) => setCycleRefId(e.target.value)}
            >
              <MenuItem key="" value="0">
                Select Stroke
              </MenuItem>
              {payCycles.map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).isValid() ? moment(item.payDate).format('YYYY-MM-DD') : ''}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              id="standard-select-currency"
              style={{ width: 180, height: 30, pb: 2 }}
              select
              size="small"
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
            >
              <MenuItem key="" value="0">
                Select Currency
              </MenuItem>
              {currencies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Button
          type="button"
          variant="outlined"
          sx={{ minWidth: '180px', p: 1, px: 2, color: 'white', backgroundColor: '#000000' }}
          startIcon={<PublishIcon />}
          onClick={() => saveSsbFile()}
        >
          Save File
        </Button>
      </Stack>
      <Divider sx={{ borderBottomWidth: '5px', mb: 2, backgroundColor: '#000000' }} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Employee #</TableCell>
              <TableCell align="left">ID Number</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Reference</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details.map((row, i) => (
              <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="left">{row.employeenumber}</TableCell>
                <TableCell align="left">{row.idnumber}</TableCell>
                <TableCell align="left">{row.employeeName}</TableCell>
                <TableCell align="left">{row.reference}</TableCell>
                {/* <TableCell align="right">{Number(row.amount) + Number(row.decimals) / 100}</TableCell> */}
                <TableCell align="right">{Number(row.amount)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </Page>
  );
};

export default ExtractSsb;
